import Typography from '@components/typography';
import React from 'react';
import '../../styles/card.scss';

interface CardPanelProps {
  icon: string;
  title: string;
  content: string;
}

const CardPanel: React.FC<CardPanelProps> = ({ title, icon, content }) => {
  return (
    <div className="card__panel">
      <div className="card__panel-title">
        <img className="card__panel-title-icon" src={icon} alt="card icon" />
        <div className="card__panel-title-content">
          <Typography variant="h3" size="lg">
            {title}
          </Typography>
        </div>
      </div>
      <Typography variant="body1" size="rg">
        {content}
      </Typography>
    </div>
  );
};

export default CardPanel;
